import {base} from "react-netjoy";
import {UpdateMovieType} from "../../../../pages/parse_new_films/local_state/reducer.types";
import {PendingFilmNetType} from "../../network_models/pending_film";

export function getPendingCommands(onSuccess?: (res: PendingFilmNetType) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_command`
    const req = new base.Request<any, PendingFilmNetType, any>()
    req.setEndpointFromState = () => url
    req.method = 'GET'
    req.transformResponseDataWithState = (res) => {
        console.log(res.original)
        return res.original?.data?.data || {}
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function postPendingCommand(command: string, verify_exist_path?: string, verify_not_exist_path?: string, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_command`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'POST'
    req.setBodyFromState = () => {
        return [
            {
                command: command,
                verify_exist: verify_exist_path,
                verify_not_exist: verify_not_exist_path,
            }
        ]
    }
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function deletePendingCommand(id: number, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/admin/pending_command/${id}`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'DELETE'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}
